import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHome, FiArrowLeft } from 'react-icons/fi';
import '../styles/NotFound.css';
import errorImage from '../assets/errorpage.jpeg';

const NotFound = () => {
    const navigate = useNavigate();

    // Generate random particles
    const particles = Array.from({ length: 80 }).map((_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: Math.random() * 4 + 1,
        duration: Math.random() * 15 + 10,
        delay: Math.random() * 5
    }));

    return (
        <div className="not-found-page">
            <div className="particles-container">
                {particles.map((p) => (
                    <div
                        key={p.id}
                        className="particle"
                        style={{
                            left: `${p.left}%`,
                            top: `${p.top}%`,
                            width: `${p.size}px`,
                            height: `${p.size}px`,
                            animationDuration: `${p.duration}s`,
                            animationDelay: `${p.delay}s`
                        }}
                    />
                ))}
            </div>
            <div className="not-found-container">
                <div className="illustration-container">
                    <img src={errorImage} alt="404 Error" className="error-image" loading="lazy" />

                </div>

                <div className="content-container">
                    <h1 className="error-title">Page Not Found</h1>
                    <p className="error-message">
                        We couldn't find the page you're looking for. It might have been moved, deleted, or never existed.
                    </p>

                    <div className="action-buttons">
                        <button className="btn btn-primary" onClick={() => navigate('/')}>
                            <FiHome /> Go Home
                        </button>
                        <button className="btn btn-outline" onClick={() => navigate(-1)}>
                            <FiArrowLeft /> Go Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
